
<template>
  <div id="ReadyDic">
    <div class="form-ready">
      <div class="flex1 bf-ready-l"></div>
      <div class="flex1 bf-ready-r">
        <el-form v-if="notLogin" ref="form" class="ready-Form" :model="form" :rules="rules" label-width="70px">
          <div class="ready-title">学员登录</div>
          <el-form-item label="考生号" prop="loginName">
            <el-input v-model="form.loginName" placeholder="请输入登录账号"  @keyup.enter.native="inputChange"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input show-password v-model="form.password" placeholder="请输入登录密码"  @keyup.enter.native="inputChange"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="check_key" style="margin-bottom: 10px;">
            <el-input v-model="form.check_key" placeholder="请输入验证码"  @keyup.enter.native="inputChange">
              <img :src="yzmImg" @click="getImgYzm()" slot="append" style="width: 80px;height: 34px;padding-right: 3px;cursor: pointer;" />
            </el-input>
          </el-form-item>
          <div class="disFlex between" style="font-size: 14px;margin-bottom: 20px;"><span></span><span style="#9A9A9A">考生须知</span></div>
          <el-form-item label="" prop="check_key" style="margin-bottom: 10px;">
            <el-button type="primary" style="width: 100%;" @click="onSubmit">登录</el-button>
          </el-form-item>
        </el-form>
        <div v-else class="ready-not">
           <div class="kssj-time"><img src="../assets/images/kssj.png"/>考试时间：</div>
           <div class="kssj-time" style="padding-left: 60px;">2021-12-15 18:00:00  至  2021-12-15 20:00:00</div>
           <div class="kssj-time"><img src="../assets/images/djs.png"/>距开考时间还有：</div>
           <div class="kssj-time" style="padding-left: 60px;">{{djstime}}</div>
           <div class="kssj-time" style="margin-top: 50px;"><el-button style="width: 100%;" :type="!timer?'primary':'info'" @click="startKs()">开始考试</el-button></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    format
  } from '@/assets/js/common.js';
  export default {
    name: 'Kaoshi',
    data() {
      return {
        notLogin:true,
        form:{},
        rules:[],
        yzmImg: '/safety/get_check_key.htm?v=' + Math.random(),
        timer:null,
        djstime:'00:00:00'
      }
    },
    methods: {
      onSubmit: function() {
        if (this.yidaNum < this.tiji.length) {
          this.$confirm('还有题目未作答，确定要提交么？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            center: true,
            type: 'warning'
          }).then(() => {
            this.saveTj();
          }).catch(() => {
            // console.log('9562316046')
          });
        } else {
          this.saveTj();
        }
      },
      saveTj: function() {
        var tijilist = this.tiji;
        var list = [];
        this.istj=true;//代表已提交
        tijilist.map((item) => {
          var fraction = 0;
          if (item.itype == '1') {
            fraction = this.sjData.itype1Fraction
          } else if (item.itype == '2') {
            fraction = this.sjData.itype2Fraction
          } else if (item.itype == '3') {
            fraction = this.sjData.itype3Fraction
          } else if (item.itype == '4') {
            fraction = this.sjData.itype4Fraction
          } else if (item.itype == '5') {
            fraction = this.sjData.itype5Fraction
          }
          var obj = {
            questionsid: item.id,
            itype: item.itype,
            fraction: fraction,
            conts: item.myanswer
          };
          var a = [];
          item.dalist.map((d) => {
            // 选择题
            if (item.itype == '1' && d.iscorrect == '1') {
              obj.daans = d.order;
            } else if (item.itype == '2' && d.iscorrect == '1') {
              // 多选题
              a.push(d.order);
            } else if (item.itype == '3') {
              // 判断题
              obj.daans = d.iscorrect;
            } else if (item.itype == '5') {
              obj.daans = d.keyword;
            }
          });
          if (item.itype == '2') {
            obj.daans = a.join(',');
            obj.conts = obj.conts.join(',');
          }
          list.push(obj);
        })
        var params = {
          productid: sessionStorage.getItem('productIdSj'),
          papersid: this.sjData.id,
          startTime: this.startTime,
          list: JSON.stringify(list)
        };
        this.$axios.post('/kt/ktQuestionsUser/add.htm', this.$qs.stringify(params))
          .then(res => {
            var data = res.data;
            if (data.stat == '1') {
              sessionStorage.setItem('myanswerId', data.data)
              this.$message({
                message: '提交成功！',
                type: 'success'
              });
              const {href} = this.$router.resolve({
                name: 'Ckjx',
                query: {
                }
              });
              window.open(href, '_blank');
              window.opener=null;
              window.open('','_self');
              window.close();


            } else {
              this.$message.error(data.message);
            }
          })
      },
      getImgYzm:function(){
        this.yzmImg='/safety/get_check_key.htm?v=' + Math.random();
      }
    },
    components: {},
    created: function() {
     // 设置考试的开始时间
      var today = new Date();
      var year = today.getFullYear();
      this.startTime = format('YYYY-MM-DD hh:mm:ss');
      var $this = this;
      if(this.$route.query.id){
        this.notLogin=false;
        var kstime=new Date('2021-12-15 18:00:00').getTime();
        this.timer=setInterval(function(){
          var nowtime = new Date().getTime();
          // 表示已经开始考试
          if(nowtime>=kstime){
            clearInterval($this.timer);
            $this.timer=null;
          }else{
            var cha=kstime-nowtime;
            var hours=parseInt(cha/1000/60/60);
            var minities=parseInt(cha/1000/60%60);
            var seconds=parseInt(cha/1000%60);
            hours=hours>9?hours:'0'+hours;
            minities=minities>9?minities:'0'+minities;
            seconds=seconds>9?seconds:'0'+seconds;
            $this.djstime=hours+':'+minities+':'+seconds;
          }
        },1000)
      }else{
        this.notLogin=true;
      }
    },
    // 页面关闭之前   先提交试卷
    beforeDestroy:function(){

    }
  }
</script>

<style>
  #ReadyDic{
    background-color: #fff;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }
  .form-ready{
    width: 68vw;
    height: 64vh;
    margin: 18vh auto 0;
    display: flex;
    box-shadow: 0 0 50px rgba(0,150,136,0.1);
    border-radius: 20px;
    border: 1px solid rgba(30,116,255,0.1);
    overflow: hidden;
  }
  .form-ready .flex1{
    flex:1;
  }
  .bf-ready-l{
    background: url(../assets/images/test.png) 0 0 no-repeat;
    background-size: 100% 100%;
  }
  .bf-ready-r{
    position: relative;
    border-left: 0;
    border-left: 2px solid rgba(30,116,255,0.1);
    background: url(../assets/images/ready.png) 0 0;
    /* background-size: 100% 100%; */
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .ready-Form{
    width: 20vw;
    margin: 0px auto;
  }
  .ready-Form .el-input-group__append, .el-input-group__prepend{
    padding: 0px;
  }
  .ready-title{
    font-size: 26px;
    text-align: center;
    color: #0071ba;
    font-weight: 500;
    letter-spacing: 2px;
    padding: 20px 0 70px;
  }
  div.qipao{
    right: 0;
    position: absolute;
    box-shadow: 0 0 0 1px #6d9cc8 inset, 0 0 15px #6d9cc8 inset;
    color: currentColor;
    display: inline-block;
    text-decoration: none;
    border-radius: 50%;
    transition: transform 0.4s linear, box-shadow 0.15s linear, margin 0.1s linear, width 0.1s linear, height 0.1s linear;
  }
  div.qipao:before{
    background-color: #fff;
    border-radius: 50%;
    content: "";
    display: block;
    opacity: 0.5;
    position: absolute;
    top: 0.75em;
    left: 0.75em;
    width: 1em;
    height: 0.5em;
    transform: rotate(-45deg);
  }
  .qipao div{
    width: 100px;
    height: 100px;
    border-radius: 50%;
  }
  .kssj-time{
    font-size: 26px;
    color: #111;
    margin: 20px auto;
    text-align: left;
    padding: 0 20px;
    display: flex;
    align-items: center;
  }
  .kssj-time img{
    width: 30px;
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Ready.vue